import { createContext, Dispatch, SetStateAction } from "react"
import { DiagramConfig, EntityConfig } from "../types/diagram.ts"
import { EntityType } from "../backend/types/entity.ts"

export const DiagramConfigContext = createContext({
    config: {} as unknown as DiagramConfig,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getEntityConfigOrDefault: (() => {}) as (type: EntityType) => EntityConfig
})

export const CustomizeDiagramConfigContext = createContext({
    setConfig: (() => {}) as Dispatch<SetStateAction<DiagramConfig>>,
    resetConfig: (() => {}) as () => void
})
